import fetch from 'node-fetch';
import utils from "../../universal/utils";

const basePath = utils.getEdgeBasePath();

function fetchAdmin(url, options = {}) {
  return fetch(url, { ...options, credentials: "include" });
}

async function parseAdminResponse(response) {
  let data = {};
  try {
    data = await response.json();
  } catch (error) {
    if (!response.ok) throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    throw error;
  }
  if (!response.ok || data?.ok === false) {
    throw new Error(data?.error || data?.err || data?.message || `HTTP ${response.status}`);
  }
  return data;
}

export const selectMatch = (matchId) => ({
  type: "ACD_SELECT_MATCH",
  matchId,
});

export const setStatus = (status) => ({
  type: "ACD_SET_STATUS",
  status,
});

export const applyFrame = (frame) => ({
  type: "ACD_FRAME",
  frame,
});

export const applyEvent = (event) => ({
  type: "ACD_EVENT",
  event,
});

export const resetDebugger = () => ({
  type: "ACD_RESET",
});

export const setError = (error) => ({
  type: "ACD_ERROR",
  error,
});

export const setInstrumentation = ({ matchId, userId, enabled }) => {
  return async (dispatch) => {
    if (!matchId || !userId) return;
    try {
      const response = await fetchAdmin(
        `${basePath}/api/v7/admin/match/${matchId}/debug-instrumentation/adpass/${userId}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ enabled }),
        }
      );
      await parseAdminResponse(response);
      dispatch(setStatus(enabled ? "requested" : "idle"));
    } catch (error) {
      console.error('Error setting debug instrumentation:', error);
      dispatch(setError(error.message || String(error)));
    }
  };
};

export const fetchActiveMatches = ({ userId }) => {
  return async (dispatch) => {
    if (!userId) return [];
    try {
      const response = await fetchAdmin(
        `${basePath}/api/v7/admin/matches/search/adpass/${userId}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ status: "STARTED", limit: 50 }),
        }
      );
      const data = await parseAdminResponse(response);
      return data.matches || [];
    } catch (error) {
      console.error('Error fetching active matches:', error);
      dispatch(setError(error.message || String(error)));
      return [];
    }
  };
};
